import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  input,
} from '@angular/core';
import { PayeeDropzoneDirective } from './payee-dropzone.directive';
import { PayeeIconComponent } from '../payee-icon/payee-icon.component';

@Component({
  selector: 'payee-dropzone',
  templateUrl: './payee-dropzone.component.html',
  styleUrls: ['./payee-dropzone.component.scss'],
  imports: [
    PayeeDropzoneDirective,
    PayeeIconComponent,
    forwardRef(() => PayeeDropzoneComponent),
  ],
  host: {
    '[attr.width]': 'width()',
  },
})
export class PayeeDropzoneComponent {
  readonly width = input<string>();
  @Input() multiple = true;
  @Input() heading = 'Tölts fel egy fájlt (Max. 10MB)';
  @Input() description = '';
  @Input() accept = `
						application/msword,
            application/vnd.openxmlformats-officedocument.wordprocessingml.document,
            application/vnd.ms-powerpoint,
            application/vnd.openxmlformats-officedocument.presentationml.presentation,
            text/plain,
            application/vnd.ms-xpsdocument,
            image/jpg,
            image/jpeg,
            image/png,
            image/gif,
            image/bmp,
            image/tiff,
            image/svg+xml,
            image/vnd.adobe.photoshop,
            application/pdf,
            application/zip,
            application/x-rar-compressed,
            application/octet-stream,
            application/gzip,
            application/x-tar,
            application/vnd.ms-excel,
            application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
            application/vnd.eszigno3+xml,
            .es3
						`;
  @Input() isDisabled = false;
  isHovering = false;

  @Output() dropped = new EventEmitter<FileList>();

  toggleHover(event: boolean): void {
    this.isHovering = event;
  }

  uploadClick(upload: HTMLInputElement) {
    if (!this.isDisabled) {
      upload.click();
    }
  }

  uploadChange(event: Event) {
    if (!this.isDisabled) {
      const upload = event.target as HTMLInputElement;
      if (upload.files) {
        this.filesChosen(upload.files);
      }
    }
  }

  filesChosen(files: FileList) {
    if (!this.isDisabled) {
      this.dropped.next(files);
      const upload = document.querySelector(
        'input[type=file]',
      ) as HTMLInputElement;
      upload.value = ''; // reset the input element
    }
  }
}
